export const TransferStatuses = {
	Rejected: 'Rejected',
	Received: 'Received',
	Requested: 'Requested',
	Failed: 'Failed',
};
